import React, { useEffect, useMemo, useState } from 'react'
import styles from './NotificationPopup.module.css'
import luckyTypeBackground from '@assets/lucky-spins/lucky-spin-mode-notification-background.png'
import { useLuckySpinsStore } from '@stores'
import { useTranslation } from '@amusnet/translations/react'
import { CloverAnimation } from '@amusnet/react-ui'

// TODO: remove when promo removed from platform
interface NotificationPopupProps {
    shouldShow: boolean
    duration?: number
    children?: React.ReactNode
    type?: NotificationType
}

type NotificationType = 'lucky' | 'error'

const NotificationPopup: React.FC<NotificationPopupProps> = ({
    shouldShow = false,
    duration = 5000,
    children,
    type,
}) => {
    const { t } = useTranslation()
    const setShowLuckySpins = useLuckySpinsStore((state) => state.setShowLuckySpins)

    const [visible, setVisible] = useState(false)

    useEffect(() => {
        if (shouldShow) {
            setVisible(true)

            const hideTimer = setTimeout(() => {
                setVisible(false)
                setShowLuckySpins(false)
            }, duration)

            return () => {
                clearTimeout(hideTimer)
            }
        }
    }, [shouldShow, duration])

    const renderContent = useMemo(() => {
        switch (type) {
            case 'lucky':
                return (
                    <div
                        style={{
                            backgroundImage: `url(${luckyTypeBackground})`,
                            width: '800px',
                            height: '140px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'left',
                            borderRadius: '16px',
                            color: 'white',
                        }}
                    >
                        <div className="px-[30px] flex justify-center align-center w-[235px]">
                            <div style={{ scale: '0.5' }}>
                                <CloverAnimation pause={!visible} />
                            </div>
                        </div>
                        <div className="font-normal text-[30px] leading-[40px] tracking-[0px] align-middle w-auto">
                            {`${t('gameui.bonusSystem.luckySpinsNotificationPrefix')} `}
                            <span className="font-bold text-[38px] leading-[40px] tracking-[0px] align-middle bg-[linear-gradient(180deg,#F6C101_15.5%,#FFFF54_48%,#DAA80C_87.5%)] bg-clip-text text-transparent">
                                {t('gameui.bonusSystem.luckySpin', undefined, 2)}
                            </span>
                            {` ${t('gameui.bonusSystem.luckySpinsNotificationSuffix')}`}
                        </div>
                    </div>
                )
            case 'error':
                return (
                    <div
                        style={{
                            background:
                                'linear-gradient(#1E2024,#1E2024) padding-box, linear-gradient(180deg,#F9C246 0%,#F9E746 47.92%,#F9C246 100%) border-box',
                            border: '3px solid transparent',
                            boxShadow: '0 10px 30px rgba(0,0,0,0.4)',
                            width: '800px',
                            height: '140px',
                            borderRadius: '16px',
                            color: 'white',
                        }}
                    >
                        {children}
                    </div>
                )
            default:
                return <div className={styles.defaultContent}>{children}</div>
        }
    }, [type, visible])

    return <div className={`${styles.popup} ${visible ? styles.show : ''}`}>{renderContent}</div>
}

export default NotificationPopup
